import React from 'react'
import { useLocaleStore } from '../../../Contexts/LocaleContext'
import { MicrophoneAllowedIcon } from '../../../Icons/Miscellaneous'

const MicrophoneModalWaiting = (): JSX.Element => {
  const translation = useLocaleStore((state) => state.currentTranslations)

  return (
    <div className='rf-max-w-[500px] rf-px-16 rf-py-16 rf-flex rf-flex-col rf-justify-center rf-items-center rf-gap-4'>
      <MicrophoneAllowedIcon className='rf-h-10' />
      <p className='rf-text-size-auto rf-text-center'>
        {translation.microphone.allow}
      </p>
    </div>
  )
}

export default MicrophoneModalWaiting
